// import translationEN from "@assets/rt-translations/translations/admin/en.json";
import translationFR from '@assets/locales/fr/translations.json'; //"@assets/rt-translations/translations/admin/fr.json";
// import translationDE from "@assets/rt-translations/translations/admin/de.json";
// import translationIT from "@assets/rt-translations/translations/admin/it.json";

export enum Locales {
  EN = 'en',
  FR = 'fr',
  DE = 'de',
  IT = 'it',
}

export namespace Locales {
  export const selectItems = () =>
    [Locales.EN, Locales.FR, Locales.DE, Locales.IT].map((it) => ({
      label: it,
      value: it,
    }));
}

export const LocaleTranslations = {
  [Locales.FR]: {
    translation: translationFR,
  },
  // [Locales.EN]: {
  //   translation: translationEN,
  // },
  // [Locales.DE]: {
  //   translation: translationDE,
  // },
  // [Locales.IT]: {
  //   translation: translationIT,
  // },
};
